import { useEffect, useState } from 'react';
import Canvas from './canvas';
import './editor.css';
import React from 'react';
import { ajax } from 'jquery';

export type Country = {
    type: 'country' | 'chat';
    name?: string;
    country?: string;
    expressionType?: string;
    expressionOrientation?: number; //0 正面 1 朝左 2 朝右
    size?: number;
    rotation?: number; // 旋转角度（度数）
    position: { x: number; y: number };
    chatType?: "left_chat" | "right_chat";
    chatText?: string;
    img?: HTMLImageElement;
    expressionImg?: HTMLImageElement;
}

function replaceSpacesWithUnderscoresUsingReplaceAll(str: string): string {
    return str.replaceAll(' ', '_');
}

let prevComicData: any = undefined

const CommitEditor = (props: any) => {

    const [activedCountries, setActivedCountries] = useState<any>([])
    const [countrys, setCountrys] = useState<Country[]>([]);
    const [isShowCountrySelector, setIsShowCountrySelector] = useState<boolean>(false);
    const [isShowExpressionSelector, setIsShowExpressionSelector] = useState<boolean>(false);
    const [currentCountry, setCurrentCountry] = useState<number>();
    const [selectedCountryIndex, setSelectedCountryIndex] = useState<number>(-1);

    useEffect(() => {
        const loadUserData = async () => {
            try {
                const result = await ajax({
                    method: "GET",
                    url: '/api/v1/countryball_card/user',
                })
                setActivedCountries(result.activedCountries)
            } catch (err) {
                console.warn('Failed to load user data, likely not logged in')
                setActivedCountries([])
            }
        }
        
        if (props.mode === 'edit') {
            loadUserData()
        }
    }, [props.mode])

    useEffect(() => {
        if (props.comicData) {
            setCountrys([]);

            // 创建按顺序加载的 Promise 数组
            const loadPromises = props.comicData.map(async (co: any) => {
                if (co.type === 'country') {
                    const img = new Image();
                    const expressionImg = new Image();
                    img.crossOrigin = 'anonymous';
                    img.src = 'https://oss.usecubes.cn/countryballs/new_balls/' + replaceSpacesWithUnderscoresUsingReplaceAll(co.country) + '.png';
                    img.style.display = 'none';
                    expressionImg.crossOrigin = 'anonymous';
                    expressionImg.src = `/assets/expression/eye_${co.expressionType}_${co.expressionOrientation}.png`;
                    expressionImg.style.display = 'none';
                    document.body.appendChild(img);
                    document.body.appendChild(expressionImg);

                    // 用 Promise 包装 onload
                    await new Promise<void>((resolve) => {
                        img.onload = () => resolve();
                    });

                    return {
                        type: 'country',
                        name: replaceSpacesWithUnderscoresUsingReplaceAll(co.name),
                        country: co.country,
                        size: co.size,
                        rotation: co.rotation || 0, // 如果没有rotation属性，默认为0
                        position: co.position,
                        img,
                        expressionType: co.expressionType,
                        expressionOrientation: co.expressionOrientation,
                        expressionImg: expressionImg
                    } as Country;
                } else {
                    // 聊天类型直接返回
                    return {
                        type: 'chat',
                        chatType: co.chatType,
                        chatText: co.chatText,
                        size: co.size || 1.0, // 如果没有size属性，默认为1.0
                        rotation: co.rotation || 0, // 如果没有rotation属性，默认为0
                        position: co.position,
                    } as Country;
                }
            });

            // 按顺序等待所有 Promise 完成
            Promise.all(loadPromises).then(loadedCountries => {
                setCountrys(loadedCountries);
            });
        }
    }, [props.comicData]);



    const removeCountryAtIndex = (index: number) => {
        const newCountrys = countrys.filter((_, idx) => idx !== index);
        setCountrys(newCountrys);
    };

    const updateCountryPosition = (index: number, deltaX: number, deltaY: number) => {
        const updatedCountrys = countrys.map((country, i) =>
            i === index ? { ...country, position: { x: country.position.x + deltaX, y: country.position.y + deltaY } } : country
        );
        setCountrys(updatedCountrys);
    };

    const updateCountrySize = (index: number, newSize: number) => {
        const updatedCountrys = countrys.map((country, i) =>
            i === index ? { ...country, size: newSize } : country
        );
        setCountrys(updatedCountrys);
    };

    const updateCountryRotation = (index: number, newRotation: number) => {
        const updatedCountrys = countrys.map((country, i) =>
            i === index ? { ...country, rotation: newRotation } : country
        );
        setCountrys(updatedCountrys);
    };

    const showCountrySelector = () => {
        setIsShowCountrySelector(true)
    }

    function addCountry(cn: string, e: React.MouseEvent<HTMLImageElement>) {
        const img = e.target as HTMLImageElement;;

        const randomExpressionType = Math.floor(Math.random() * 14);
        const randomExpresionOrientation = Math.floor(Math.random() * 3);
        const expressionImg = new Image();
        expressionImg.src = `/assets/expression/eye_${randomExpressionType}_${randomExpresionOrientation}.png`;

        expressionImg.onload = () => {
            const newCountry: Country = {
                type: 'country',
                name: cn,
                country: cn,
                size: 200,
                rotation: 0, // 默认无旋转
                position: { x: Math.floor(Math.random() * (500 - 100 + 1)) + 100, y: Math.floor(Math.random() * (500 - 100 + 1)) + 100 },
                img,
                expressionType: `${randomExpressionType}`,
                expressionOrientation: randomExpresionOrientation,
                expressionImg
            };

            setCountrys(prevArray => [...prevArray, newCountry])
            setIsShowCountrySelector(false)
        }
    }

    const prepareChangeExpression = (i: number) => {
        setCurrentCountry(i);
        setIsShowExpressionSelector(true);
    }

    const changeExpression = (i: number, t: number) => {
        const index = currentCountry;

        const expressionImg = new Image();
        expressionImg.src = `/assets/expression/eye_${i}_${t}.png`;

        expressionImg.onload = () => {
            const newProperties = {
                expressionType: `${i}`,
                expressionOrientation: t,
                expressionImg: expressionImg
            }
            // console.log(newProperties,index)
            const updatedCountrys = countrys.map((country, i) =>
                i === index ? { ...country, ...newProperties } : country
            );

            setCountrys(updatedCountrys);
            setIsShowExpressionSelector(false);
        }
    }

    const moveCountry = (index: number, dir: number) => {
        if (index === 0 && dir < 0) return; // 如果是第一个元素，则无法上移
        if (index === countrys.length - 1 && dir > 0) return; // 如果是最后一个元素，则无法下移

        const newCountrys = [...countrys];
        // 交换当前元素和前一个元素
        [newCountrys[index + dir], newCountrys[index]] = [newCountrys[index], newCountrys[index + dir]];
        setCountrys(newCountrys);
    }

    const addDialougue = () => {
        const newCountry: Country = {
            type: 'chat',
            chatType: "left_chat",
            chatText: "",
            size: 1.0, // 对话框的缩放系数，1.0表示正常大小
            rotation: 0, // 默认无旋转
            position: { x: Math.floor(Math.random() * (500 - 100 + 1)) + 100, y: Math.floor(Math.random() * (500 - 100 + 1)) + 100 },
        };

        setCountrys(prevArray => [...prevArray, newCountry])
    }


    const changeDialogueType = (index: number, type: "left_chat" | "right_chat") => {
        const newProperties = {
            chatType: type
        }

        const updatedCountrys = countrys.map((country, i) =>
            i === index ? { ...country, ...newProperties } : country
        );
        setCountrys(updatedCountrys);
    }


    const handleContentChange = (index: number, newContent: string) => {
        const updatedCountrys = [...countrys];
        updatedCountrys[index].chatText = newContent; // 更新特定元素的 content
        setCountrys(updatedCountrys); // 更新 state
    };

    const save = () => {
        const newArray = []
        for (let i = 0; i < countrys.length; i++) {
            const country = countrys[i];
            delete country['img'];
            delete country['expressionImg'];
            newArray.push(country);
        }
        props.onSave && props.onSave(newArray)
    }

    const cancel = () => {
        setCountrys([])
        props.onCancel && props.onCancel()
    }

    return (
        <div className={'comit-editor ' + props.mode}>
            {props.mode === 'edit' &&
                <div className="drag-tip-header">
                    {window.innerWidth <= 768 ?
                        "👆 选中图层，拖动移位，捏拉四角缩放，圆点旋转" :
                        "💡 选中图层后，拖动元素移动位置，拖动四角控制点缩放大小，拖动右侧圆形控制点旋转"
                    }
                </div>
            }
            <div className={'stage ' + props.mode}>
                <Canvas
                    countrys={countrys}
                    mode={props.mode}
                    onUpdatePosition={updateCountryPosition}
                    onUpdateSize={updateCountrySize}
                    onUpdateRotation={updateCountryRotation}
                    selectedIndex={selectedCountryIndex}
                    onSelectionChange={setSelectedCountryIndex}
                />
            </div>
            {
                props.mode === 'edit' &&
                <>
                    <div className="addWrap">
                        <div className="addButton common-small-btn" onClick={showCountrySelector}>
                            <span>添加国家球</span>
                        </div>
                        <div className="addButton common-small-btn" onClick={addDialougue}>
                            <span>添加对话</span>
                        </div>
                        <div className="addButton common-small-btn" onClick={cancel}>
                            <span>取消</span>
                        </div>
                        <div className="addButton common-small-btn" onClick={save}>
                            <span>保存</span>
                        </div>
                    </div>
                </>
            }

            {
                props.mode === 'edit' &&
                <div className="countryAndDialogues">
                    {countrys.map((country, index) => {
                        return <div
                            className={"countryWrap " + (country.type === "country" ? "" : "chat") + (selectedCountryIndex === index ? " selected" : "")}
                            key={`country_${index}`}
                            onClick={() => setSelectedCountryIndex(index)}
                        >
                            <div className='countryWrapContent'>

                                {country.type === "country" ? <div className="profile">
                                    <div className="avatar">
                                        <img src={country.img ? country.img.src : ''} alt="" />
                                        <img className='expressionImg' src={`/assets/expression/eye_${country.expressionType}_${country.expressionOrientation}.png`} alt="" />
                                    </div>
                                </div> : <div className="chat-content">
                                    <textarea
                                        placeholder='请输入对话内容'
                                        value={country.chatText}
                                        onChange={(e) => handleContentChange(index, e.target.value)} // 处理输入框内容变化
                                    />
                                    <div className="buttons">
                                        <div className="button small" onClick={() => { changeDialogueType(index, "left_chat") }}>左</div>
                                        <div className="button small" onClick={() => { changeDialogueType(index, "right_chat") }}>右</div>
                                        <div className="button small" onClick={() => { moveCountry(index, -1) }}>↓</div>
                                        <div className="button small" onClick={() => { moveCountry(index, 1) }}>↑</div>
                                    </div>
                                </div>}

                                {country.type === "country" && (
                                    <div className="layer-controls">
                                        <div className="buttons">
                                            <div className="button" onClick={() => { prepareChangeExpression(index) }}>修改表情</div>
                                            <div className={`button small ${index === 0 ? 'disable' : ''}`} onClick={() => { moveCountry(index, -1) }}>↓</div>
                                            <div className={`button small ${index === countrys.length - 1 ? 'disable' : ''}`} onClick={() => { moveCountry(index, 1) }}>↑</div>
                                        </div>
                                    </div>
                                )}

                                <div className="remove" onClick={() => removeCountryAtIndex(index)}>
                                    <img src="/assets/icons/remove.svg" alt="" />
                                    <p>删除</p>
                                </div>
                            </div>
                        </div>
                    })}
                </div>
            }

            {isShowCountrySelector ? <div className="countrysSelector">
                <div className="countrys-contrainer">
                    {activedCountries.map((country: any, cn_i: number) => {
                        return <div key={`img_${cn_i}`} className='img_container'  >
                            <img src={`https://oss.usecubes.cn/countryballs/new_balls/${replaceSpacesWithUnderscoresUsingReplaceAll(country.name_en)}.png`} alt={country.name_en} onClick={(e) => addCountry(country.name_en, e)} />
                        </div>
                    })}
                </div>
            </div> : null}


            {isShowExpressionSelector ? <div className="expressionSelector">
                <div className='img_container' >
                    {new Array(14).fill(null).map((_, en_i: number) => {
                        return < React.Fragment key={`img_${en_i}_1`}>
                            <img src={`/assets/expression/eye_${en_i}_1.png`} alt="" onClick={() => changeExpression(en_i, 1)} />
                            <img src={`/assets/expression/eye_${en_i}_0.png`} alt="" onClick={() => changeExpression(en_i, 0)} />
                            <img src={`/assets/expression/eye_${en_i}_2.png`} alt="" onClick={() => changeExpression(en_i, 2)} />
                        </React.Fragment>
                    })}
                </div>
            </div> : null}

        </div >
    );
}

export default CommitEditor